"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledDropdownModule = _interopRequireDefault(require("./StyledDropdown.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const StyledDropdown = _ref => {
  let {
    labelTxt,
    list,
    value,
    onChange,
    formControlProps,
    inputLabel,
    disabled,
    icon,
    infoMsg
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon ? /*#__PURE__*/_react.default.createElement("div", {
    className: _StyledDropdownModule.default.iconTooltipContainer
  }, /*#__PURE__*/_react.default.createElement(_Info.default, null), /*#__PURE__*/_react.default.createElement("p", null, infoMsg)) : null, /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    variant: "outlined",
    className: _StyledDropdownModule.default.formControl,
    disabled: disabled
  }, formControlProps), inputLabel ? /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    htmlFor: "age-simple"
  }, inputLabel) : null, /*#__PURE__*/_react.default.createElement(_Select.default, {
    value: value,
    onChange: onChange,
    name: labelTxt,
    className: _StyledDropdownModule.default.selectEmpty,
    variant: "outlined",
    MenuProps: {
      disablePortal: false,
      container: () => document.body,
      disableScrollLock: true
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    value: "default",
    className: _StyledDropdownModule.default.defaultMenuItem
  }, labelTxt || "Select a value"), list && list.map(item => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: item.value,
    value: item.value,
    className: _StyledDropdownModule.default.menuItem
  }, item.label)))));
};
StyledDropdown.propTypes = {
  inputLabel: _propTypes.default.string,
  labelTxt: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string
  })),
  onChange: _propTypes.default.func
};
StyledDropdown.defaultProps = {
  labelTxt: "",
  value: "default"
};
var _default = exports.default = StyledDropdown;